var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('DaySelector',{staticClass:"mr-2",on:{"select":_vm.load}}),_c('v-btn',{attrs:{"outlined":"","small":"","depressed":""},on:{"click":function($event){return _vm.load()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-sync")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }